import React from "react"

type Props = {
  children: React.ReactNode
}

const MobileText = ({ children }: Props) => {
  return (
    <span className="font-raleway-light font-medium text-base ml-2 text-[#B3E0F5] cursor-point">
      {children}
    </span>
  )
}

export default MobileText
